<template>
    <page-preloader v-if="isCartLoading" min-height="130px" />

    <div v-else class="recap-table">
        <div class="recap-table__row">
            <div class="recap-table__cell" v-text="'Wartość pakietów'" />
            <div class="recap-table__cell" v-text="$options.filters.currency(packageValue)" />
        </div>
        <div class="recap-table__row">
            <div class="recap-table__cell" v-text="'Stawka VAT'" />
            <div class="recap-table__cell" v-text="'23%'" />
        </div>
        <div class="recap-table__row">
            <div class="recap-table__cell" v-text="'Rabat'" />
            <div class="recap-table__cell" v-text="$options.filters.currency(0)" />
        </div>
        <div class="recap-table__row --strong">
            <div class="recap-table__cell" v-text="'Do zapłaty brutto'" />
            <div class="recap-table__cell" v-text="$options.filters.currency(totalGross)" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('drsTariffs', ['cartLocations', 'cart', 'isCartLoading']),

        packageValue() {
            return (this.cart?.total_payment_price_net || 0) / 100
        },

        totalGross() {
            return (this.cart?.total_payment_price_gross || 0) / 100
        }
    },

    watch: {
        cartLocations: {
            deep: true,
            handler() {
                this.loadCart()
            }
        }
    },

    methods: {
        ...mapActions('drsTariffs', ['loadCart'])
    },

    created() {
        if (!this.cart) {
            this.loadCart()
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.recap-table {
    margin-left: auto;
    color: var(--color-black);
    width: 280px;

    &__row {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0.25rem;

        &.--strong {
            font-weight: bold;
        }
    }

    @include media-breakpoint-down(sm) {
        &__row {
            width: 100%;
        }
    }
}
</style>